<div class="text-green-500 text-4xl mb-3" i18n>Start of negotiation</div>

<request-info mode="product" [product]="product" [company]="company" [requestType]="requestType">
  <div class="flex flex-col flex-grow place-content-center
    max-h-96 max-w-full md:max-w-[380px] p-2 md:ml-4 mb-4 md:mb-0
    bg-gray-100 border border-black border-opacity-10">
    <div i18n class="mb-2">
      In order to obtain the most precise quotation, please fill in the request with as many details as possible, for example:
    </div>
    <ul class="list-disc ml-4">
      <li i18n>amount of the material</li>
      <li i18n>type of material</li>
      <li i18n>delivery times</li>
      <li i18n>reference norms and standards</li>
      <li i18n>minimum – maximum tolerances, etc.</li>
    </ul>
  </div>
</request-info>
